import React, { useEffect, useState } from 'react'
import LeftSideMenu from '../components/LeftSideMenu'
import UserNav from '../components/UserNav'
import Loader from '../components/Loader'

const Settings = () => {

    const [pageLoad, setPageLoad] = useState(true)

    useEffect(() => {
        const timeout = setTimeout(() => {
            setPageLoad(false)
        }, 1000);
        return () => clearTimeout(timeout)
    },[])

    if(pageLoad) {
        return (
            <Loader />
        )
    }


    return (
        <>
            <div className='pagecontent'>
                <LeftSideMenu />
                <div className='pagecontentbox'>
                    <div className="pagetitlediv">
                        <h2 className="title">Settings</h2>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Settings